import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import AuctionNewOffersCard from '../../AuctionCards/AuctionNewOffersCard';

import { setSelectedAuctionId } from '../../../store/actions/auction.actions';
import { useFlag, useUnleashContext } from '@unleash/proxy-client-react';
import { checkFinancingEnabled } from '../../../services/fincredit';
import { CarList } from './styles';


function ClubeOffersList({ auctions }) {
  const selectedAuctionId = useSelector(state => state.ui.selectedAuctionId);
  const { user } = useSelector(state => state.authentication);
  const updateContext = useUnleashContext();
  const enabledSimulationBanner = useFlag('banner-simulacao');
  const dispatch = useDispatch();

  const handleOnLoad = id => {
    if (id === selectedAuctionId) {
      dispatch(setSelectedAuctionId());
      document.getElementById(id).scrollIntoView();
    }
  };

  const fetchData = async () => {
    try {
      await checkFinancingEnabled(user?.email);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    updateContext({ userId: user?.email });
  }, [user?.email]);

  useEffect(() => {
    if (enabledSimulationBanner) {
      fetchData();
    }
  }, [enabledSimulationBanner]);

  return (
    <CarList>
      {auctions?.map(auction => (
        <AuctionNewOffersCard 
          key={auction._id} 
          auction={auction} 
          previousCard={handleOnLoad} 
          canShowTagClube={auction.canShowTagClube} 
        />
      ))}
    </CarList>
  );
}

export default ClubeOffersList;
